import get from "lodash/get";


export function getUser(state: any) {
    let obj = get(state, ["admin", "user"]);
    if (obj) {
        return obj;
    }
    return {};
}

export function fetchAllDSABankMasters(state: any) {
    let banksOfAdmin = get(state, ["admin", "bankMasters", "banksOfAdmin"]) || [];
    return banksOfAdmin;
}

export function fetchAllBankMasters(state: any) {
    let banksOfAdmin = get(state, ["admin", "bankMasters", "bankMasters"]) || [];
    return banksOfAdmin;
}

export function getAccountSmtpSelector(state: any) {
    return get(state, ["admin", "accountSettings", 'smtp']) ?? {};
}

export function getAccountSmtpSavedSelector(state: any) {
    return get(state, ["admin", "accountSettings", 'smtpSaved']) ?? {};
}

export function getCurrentUserRole(state: any) {
    let obj = get(state, ["admin", "user", "role", "permissions"]);
    if (obj) {
        const roles: any = [];
        obj.forEach((p: any) => {
            if (p && p.name) {
                const perm: any = [];
                p.items.forEach((item: any) => {
                    if (item && item.name && item.checked) {
                        perm.push(item.name);
                    }
                });
                roles.push({ [p.name]: perm })
            }
        })
        return roles;
    }
    return [];
}

export function isAuthenticated(state: any) {
    let isAuth = get(state, ["admin", "auth", "isAuth"]);
    if (isAuth) {
        return isAuth;
    }
    return false;
}

export function fetchUserProfileSelector(state: any) {
    return get(state, ["admin", "profile", "user"]) || false;
}


export function fetchUserVerifyMessage(state: any) {
    return get(state, ["admin", "users", "userMetaVerifyCompleted"]) || null;
}

export function fetchUsers(state: any) {
    return get(state, ["admin", "users", "users"]) || [];
}


export function usersCount(state: any) {
    let usersCount = get(state, ["admin", "users", "usersCount"]);
    if (usersCount) {
        return usersCount;
    }
    return null;
}

export function addUpdateSuccess(state: any) {
    let addUpdateSuccess = get(state, ["admin", "users", "addUpdateSuccess"]);
    if (addUpdateSuccess) {
        return addUpdateSuccess;
    }
    return false;
}

export function fetchRolesSelector(state: any) {
    let roles = get(state, ["admin", "roles", "roles"]) || [];
    return roles;
}

export function roleCountSelector(state: any) {
    let counts = get(state, ["admin", "roles", "count"]) || null;
    return counts;
}
//rolePermissions

export function rolePermissions(state: any) {
    let permissions = get(state, ["admin", "roles", "permissions", "permissions"]) || {};
    return permissions;
}

export function addRoleSuccess(state: any) {

    let success = get(state, ["admin", "roles", "success"]);
    if (success) {
        return success;
    }
    return false;
}

export function sidebarCollapseSelector(state: any) {
    let data = get(state, ["sidebarCollapse"]);
    if (data) {
        return data;
    }
    return null;
}

export function getCurrentUserProfile(state: any) {
    let profile = get(state, ["account", 'user']);
    if (profile) {
        return profile;
    }
    return [];
}

export function fetchUserSelector(state: any) {
    let fetchDSACompanyProfile = get(state, ["admin", "users", "userProfile"]) || [];
    return fetchDSACompanyProfile;
}


export function getPreviewImageSelector(state: any) {
    let applicationProfile = get(state, ["admin", "application", "documentPreview"]) || null;
    return applicationProfile;
}

export function isToggleThemeCustomizeSelector(state: any) {
    let channelVariables = get(state, ["admin", "accountSettings", "isToggleThemeCustomize"]) || false;
    return channelVariables;
}

export function fetchAccountSettingsSelector(state: any) {
    let channelVariables = get(state, ["admin", "accountSettings"]) || false;
    return channelVariables;
}
